export interface BaseProviderState {
  initializing?: boolean
  isError?: boolean
}

export const Initial = {
  initializing: true,
  isError: false
}
